import { BillingSubscription, BillingPaymentMethod, BillingInvoice, BillingUpcomingInvoice } from 'src/common-services'
import { BaseClient } from 'src/common-services/clients/base-client'

export class BillingClient extends BaseClient {
  getSubscription(): Promise<BillingSubscription> {
    return this.call<BillingSubscription>('/billing/subscription', 'GET')
  }

  createPaymentMethodIntent(): Promise<string | null> {
    return this.call('/billing/payment-methods/intent', 'POST')
  }

  getPaymentMethods(): Promise<BillingPaymentMethod[]> {
    return this.call<BillingPaymentMethod[]>('/billing/payment-methods', 'GET')
  }

  deletePaymentMethod(id: string): Promise<void> {
    return this.call(`/billing/payment-methods/${id}`, 'DELETE')
  }

  setDefaultPaymentMethod(id: string): Promise<void> {
    return this.call(`/billing/payment-methods/${id}/default`, 'PUT')
  }

  getUpcomingInvoice(): Promise<BillingUpcomingInvoice> {
    return this.call<BillingUpcomingInvoice>('/billing/upcoming-invoice', 'GET')
  }

  getInvoices(): Promise<BillingInvoice[]> {
    return this.call<BillingInvoice[]>('/billing/invoices', 'GET')
  }

  getInvoiceById(id: string): Promise<BillingInvoice | undefined> {
    return this.call<BillingInvoice | undefined>(`/billing/invoices/${id}`, 'GET')
  }

  getIsStripeCustomerExists(): Promise<boolean> {
    return this.call<boolean>('/billing/ensure-customer', 'GET')
  }
}
